import { observer } from 'mobx-react-lite';

import { Icons } from '@/assets/icons/icons';
import { XStack } from '@/components/ui';
import { userStore } from '@/stores/user.store';

import { useProjectMembers } from '../project-members.query';

import {
  getOtherMembers,
  getProjectTeamName,
  isProjectPrivate,
} from './project-visibility';

import type { Project } from '@littlebird/sdk';

type ProjectVisibilityBadgeProps = {
  project: Project;
};

export const ProjectVisibilityBadge = observer(
  ({ project }: ProjectVisibilityBadgeProps) => {
    const { data: members, isLoading } = useProjectMembers(project.id, true);
    const others = getOtherMembers(members, userStore.userId);
    const isPrivate = isProjectPrivate(project, others);
    const teamMember = members?.find((member) => member.teamId !== null);

    if (isLoading || !members) return null;

    const Icon = isPrivate ? Icons.lock : Icons.attendees;
    const label = isPrivate
      ? 'Private'
      : teamMember
        ? getProjectTeamName(teamMember)
        : 'Shared';

    return (
      <XStack className="items-center gap-1.5 rounded-full border border-border px-2 py-1 text-xs text-foreground-muted">
        <Icon className="size-3 shrink-0" />
        <span>{label}</span>
      </XStack>
    );
  }
);
